import { useState, forwardRef } from "react";

const InputInline = ({ onAdd, skillType }, ref) => {
  const [value, setValue] = useState("");

  const handleSubmit = () => {
    const trimmed = value.trim();
    if (trimmed) {
      onAdd(trimmed);
      setValue("");
    }
  };

  return (
    <input
      id={`search-agent-input-${skillType}`}
      type="text"
      placeholder='Type terms or phrases here and press "Enter"'
      value={value}
      ref={ref}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSubmit();
        }
      }}
      onBlur={handleSubmit}
      className="search-agent-input mt-auto min-w-full flex-grow bg-transparent outline-none border-none"
    />
  );
};

export default forwardRef(InputInline);
